import {
  isExportPdfViewOpenAtom,
  isExportPngViewOpenAtom,
} from "frontend/app-header/left-header/atoms/left-header-atoms";
import { ExportPngView } from "frontend/app-header/left-header/views/export/export-png-view";
import { ExportPdfView } from "frontend/app-header/left-header/views/export/export-pdf-view";
import { useAtomValue } from "jotai";

export const ExportView = () => {
  const isExportPdfViewOpen = useAtomValue(isExportPdfViewOpenAtom);
  const isExportPngViewOpen = useAtomValue(isExportPngViewOpenAtom);

  return (
    <>
      {isExportPdfViewOpen && <ExportPdfView />}
      {isExportPngViewOpen && <ExportPngView />}
    </>
  );
};
